<template>
  <div class="modal modal-fullscreen modal-filter-details fade" id="modal-add-talent" role="dialog" aria-labelledby="shortlist-modal-label" aria-hidden="true">
    <div class="modal-dialog" data-backdrop="true" data-keyboard="true">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="shortlist-modal-label">
            <template v-if="$userIsAdmin">Add {{ $starLabelPlural | sentenceCase }}</template>
            <template v-else-if="$userIsManager">Apply For {{ $starLabelPlural | sentenceCase }}</template>
          </h4>
        </div>
        <div class="modal-body">
          <talent-filtering v-if="visible" :existing-talent="this.booking.talent" scroll-target="#modal-add-talent .modal-body" :booking-budget="this.booking.budget_per_star" :booking="this.booking" />
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-lg btn-danger pull-left" data-dismiss="modal" @click="handleModalClose"><i class="fa fa-close"></i> Cancel</button>
          <ladda-button
            type="button"
            class="btn btn-lg btn-primary"
            :click="handleSaveAdditionalTalentCallback">
            <i class="fa fa-check"></i> Save
          </ladda-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { map } from 'lodash'
import LazyLoading from 'codium-lazy-loading'
import $ from 'jquery'
import TalentFiltering from '../misc/TalentFiltering'

export default {
  data () {
    return {
      talentToAdd: [],
      searching: false,
      search: {
        name: null
      },
      visible: false
    }
  },

  components: {
    TalentFiltering,
    LazyLoading
  },

  computed: {
    ...mapState('booking/request', { booking: 'request' }),
    ...mapState('filtering', ['selectedStars'])
  },

  mounted () {
    $(this.$el).on('hidden.bs.modal', () => {
      this.talentToAdd = []
      this.search.name = null
      this.visible = false
    })

    $(this.$el).on('show.bs.modal', () => {
      this.visible = true
    })
  },

  beforeDestroy () {
    this.setSelectedStars([])
  },

  methods: {
    ...mapActions('filtering', ['setSelectedStars', 'clearAllFilters']),
    ...mapActions('booking/request', ['addAdditionalBookingRequestTalent']),

    /**
     * Save the selected additional talent against the booking as hidden responses.
     *
     * @return Promise
     */
    handleSaveAdditionalTalentCallback () {
      if (this.selectedStars.length === 0) {
        return Promise.resolve()
      } else {
        const payload = {
          id: this.booking.id,
          payload: {
            talent: map(this.selectedStars, talent => { return { 'id': talent.id, 'date': talent.date_applied_for, 'budget': talent.budget } })
          }
        }

        return this.addAdditionalBookingRequestTalent(payload)
          .then(() => {
            $(this.$el).modal('hide')
            this.handleModalClose()
          })
      }
    },

    handleModalClose () {
      this.setSelectedStars([])
      this.clearAllFilters()
    }
  }
}
</script>
